import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { X, Search, MapPin, Users } from 'lucide-react';
import { Input } from '../ui/input';
import { SHAPE_CONFIGS } from './TableShape';

// Render custom SVG shapes for serpentine, halfround, etc.
function renderTableSVG(shape, width, height, strokeColor, fillColor) {
  const svgStyle = { position: 'absolute', inset: 0, width: '100%', height: '100%' };
  
  switch (shape) {
    case 'lshape':
      return <svg viewBox={`0 0 ${width} ${height}`} style={svgStyle} preserveAspectRatio="none"><path d={`M 0 0 L ${width * 0.25} 0 L ${width * 0.25} ${height * 0.75} L ${width} ${height * 0.75} L ${width} ${height} L 0 ${height} Z`} fill={fillColor} stroke={strokeColor} strokeWidth="4"/></svg>;
    case 'ushape':
      return <svg viewBox={`0 0 ${width} ${height}`} style={svgStyle} preserveAspectRatio="none"><path d={`M 0 0 L ${width * 0.25} 0 L ${width * 0.25} ${height * 0.6} L ${width * 0.75} ${height * 0.6} L ${width * 0.75} 0 L ${width} 0 L ${width} ${height} L 0 ${height} Z`} fill={fillColor} stroke={strokeColor} strokeWidth="4"/></svg>;
    case 'halfround':
      return <svg viewBox="200 310 450 230" style={svgStyle} preserveAspectRatio="xMidYMid meet"><path d="M278.2,401.9c6.8-6.7,13.3-13.7,20.7-19.6,5.2-4.4,10.7-8.3,16.4-11.9,4.1-2.9,8.6-5.1,12.8-7.8,2.1-1.3,4.2-2.2,6.3-3.3,7.8-4.6,16-7.7,24.4-10.8,7-2.4,14-4.8,21.5-6.3,14.6-3.7,30.2-5,45.2-5.5.3.9.5,1.6.5,2.6-.3,11.7-.3,23.4-.4,35.2-.4,18-.2,35.8-.6,53.9-9.2.5-18.1,1.3-27,4-5.2,1.7-10.3,3-15.2,5.4-4.4,1.8-8.5,4-12.6,6.3-7,4.8-14,9.2-20.1,15.3-5.5,5.1-10.4,10.7-14.6,17-7.6,10.1-12.7,22.3-16.3,34.3-1.7,6.3-2.7,12.6-3.5,19.1-.2,2.3,0,4.5-.3,6.8-1.9.2-3.7,0-5.7,0-22.1,0-44.1-.3-66-.2-6.6-.3-13.3,0-19.9-.3.2-3.4.4-6.9.5-10.3,0-4.8,1.1-9.8,1.6-14.6.4-2.6,1.1-5.2,1.3-7.8.5-5.3,2.1-10.4,3.3-15.6,2-8,5.1-15.8,8-23.5,3.1-8.7,7.6-16.4,11.8-24.5,3.9-6.2,7.7-12.4,11.9-18.4,4.9-6.7,10.4-13.1,16.1-19.2h0Z" fill={fillColor} stroke={strokeColor} strokeWidth="4"/><path d="M426.6,336.8c15.1.7,30.6,2.2,45.1,6.1,7.4,1.5,14.4,4,21.4,6.6,8.3,3.3,16.5,6.5,24.3,11.2,2.1,1.1,4.2,2,6.3,3.4,4.2,2.8,8.6,5,12.7,8,5.6,3.7,11.1,7.6,16.2,12.1,7.3,6,13.8,13.1,20.5,19.9h0c5.5,6.3,11,12.7,15.8,19.5,4.1,6.1,7.8,12.4,11.6,18.6,4.1,8.2,8.5,16,11.4,24.7,2.9,7.7,5.8,15.6,7.7,23.6,1.2,5.2,2.6,10.3,3.1,15.6.2,2.6.9,5.2,1.2,7.8.4,4.8,1.4,9.8,1.4,14.6,0,3.5.2,6.9.4,10.3-6.6.2-13.3-.2-19.9,0-21.9-.4-44-.4-66-.7-1.9,0-3.7.2-5.7,0-.3-2.3-.1-4.5-.2-6.8-.7-6.4-1.7-12.8-3.3-19.1-3.5-12-8.3-24.4-15.8-34.5-4.1-6.4-8.9-12-14.3-17.2-6-6.2-12.9-10.6-19.8-15.5-4.1-2.3-8.2-4.6-12.5-6.4-4.9-2.5-9.9-3.8-15.1-5.6-8.8-2.8-17.7-3.7-26.9-4.3" fill={fillColor} stroke={strokeColor} strokeWidth="4"/></svg>;
    case 'serpentine3':
      return <svg viewBox="70 260 710 290" style={svgStyle} preserveAspectRatio="none"><path d="M215.1,336.1c8.3.4,16.7,1.1,24.9,2.4,7.2,1.4,14.3,3.1,21.4,4.8,8.7,2.8,17.3,5.2,25.6,9.2,7.5,3.4,15.2,6.8,22.2,11.1,4.5,2.8,9.2,5.4,13.3,8.8,2,1.7,4.3,3,6.4,4.6,3.7,3.1,8,5.9,11.4,9.3,2.5,2.4,5.1,4.7,7.6,7-4.5,4.9-9.5,9.3-14,14.2-15.7,15.3-31.2,31-46.9,46.5-1.3,1.4-2.5,2.8-4,4-1.8-1.4-3.3-3.1-5-4.6-5.1-4-10.3-7.8-15.9-11.1-11-6-23.2-11.2-35.7-13-7.4-1.6-14.8-2.1-22.3-1.9-8.6-.1-16.6,1.7-25,3.2-4.5,1.3-9,2.6-13.4,4.4-5.2,1.7-9.7,4.4-14.6,6.8-8.2,4.3-15.1,10-22,16.1-12.9-12.6-25.3-25.5-38.2-38-8.4-8.3-16.6-16.7-25-24.8-.7-.7-1.1-1.3-1.5-2.2,11.1-10.2,23.1-20.2,36.1-27.8,6.3-4.2,13-7.4,19.7-10.6,8.2-3.6,16.2-7.2,25-9.4,2.3-.7,4.4-1.6,6.8-2.1,4.9-1,9.6-2.6,14.6-3.4,6.6-1.4,13.2-2.5,20-3,9.4-1,19-.6,28.5-.6h0Z" fill={fillColor} stroke={strokeColor} strokeWidth="4"/><path d="M347.8,393.5c6.9,6.1,13.8,11.8,22,16.1c4.9,2.4,9.4,5.1,14.6,6.8c4.4,1.8,8.9,3.1,13.4,4.4c8.4,1.5,16.4,3.3,25,3.2c7.5.2,14.9-.3,22.3-1.9c12.5-1.8,24.7-7,35.7-13c5.6-3.3,10.8-7.1,15.9-11.1c1.7-1.5,3.2-3.2,5-4.6L566.6,458.1c-2.5,2.3-5.1,4.6-7.6,7c-3.4,3.4-7.7,6.2-11.4,9.3c-2.1,1.6-4.4,2.9-6.4,4.6c-4.1,3.4-8.8,6-13.3,8.8c-7,4.3-14.7,7.7-22.2,11.1c-8.3,4-16.9,6.4-25.6,9.2c-7.1,1.7-14.2,3.4-21.4,4.8c-8.2,1.3-16.6,2-24.9,2.4h0c-9.5.1-19.1.5-28.5-.5c-6.8-.5-13.4-1.6-20-3c-5-.8-9.7-2.4-14.6-3.4c-2.4-.5-4.5-1.4-6.8-2.1c-8.8-2.2-16.8-5.8-25-9.4c-6.7-3.2-13.4-6.4-19.7-10.6c-13-7.6-25-17.6-36.1-27.8Z" fill={fillColor} stroke={strokeColor} strokeWidth="4"/><path d="M653,336c8.3.4,16.7,1.1,24.9,2.4,7.2,1.4,14.3,3.1,21.4,4.8,8.7,2.8,17.3,5.2,25.6,9.2,7.5,3.4,15.2,6.8,22.2,11.1,4.5,2.8,9.2,5.4,13.3,8.8,2,1.7,4.3,3,6.4,4.6,3.7,3.1,8,5.9,11.4,9.3,2.5,2.4,5.1,4.7,7.6,7-4.5,4.9-9.5,9.3-14,14.2-15.7,15.3-31.2,31-46.9,46.5-1.3,1.4-2.5,2.8-4,4-1.8-1.4-3.3-3.1-5-4.6-5.1-4-10.3-7.8-15.9-11.1-11-6-23.2-11.2-35.7-13-7.4-1.6-14.8-2.1-22.3-1.9-8.6,0-16.6,1.7-25,3.2-4.5,1.3-9,2.6-13.4,4.4-5.2,1.7-9.7,4.4-14.6,6.8-8.2,4.3-15.1,10-22,16.1-12.9-12.6-25.3-25.5-38.2-38-8.4-8.3-16.6-16.7-25-24.8-.7-.7-1.1-1.3-1.5-2.2,11.1-10.2,23.1-20.2,36.1-27.8,6.3-4.2,13-7.4,19.7-10.6,8.2-3.6,16.2-7.2,25-9.4,2.3-.7,4.4-1.6,6.8-2.1,4.9-1,9.6-2.6,14.6-3.4,6.6-1.4,13.2-2.5,20-3,9.4-1,19-.6,28.5-.6h0Z" fill={fillColor} stroke={strokeColor} strokeWidth="4"/></svg>;
    case 'serpentine4':
      return <svg viewBox="70 260 925 290" style={svgStyle} preserveAspectRatio="none"><path d="M215.1,336.1c8.3.4,16.7,1.1,24.9,2.4,7.2,1.4,14.3,3.1,21.4,4.8,8.7,2.8,17.3,5.2,25.6,9.2,7.5,3.4,15.2,6.8,22.2,11.1,4.5,2.8,9.2,5.4,13.3,8.8,2,1.7,4.3,3,6.4,4.6,3.7,3.1,8,5.9,11.4,9.3,2.5,2.4,5.1,4.7,7.6,7-4.5,4.9-9.5,9.3-14,14.2-15.7,15.3-31.2,31-46.9,46.5-1.3,1.4-2.5,2.8-4,4-1.8-1.4-3.3-3.1-5-4.6-5.1-4-10.3-7.8-15.9-11.1-11-6-23.2-11.2-35.7-13-7.4-1.6-14.8-2.1-22.3-1.9-8.6-.1-16.6,1.7-25,3.2-4.5,1.3-9,2.6-13.4,4.4-5.2,1.7-9.7,4.4-14.6,6.8-8.2,4.3-15.1,10-22,16.1-12.9-12.6-25.3-25.5-38.2-38-8.4-8.3-16.6-16.7-25-24.8-.7-.7-1.1-1.3-1.5-2.2,11.1-10.2,23.1-20.2,36.1-27.8,6.3-4.2,13-7.4,19.7-10.6,8.2-3.6,16.2-7.2,25-9.4,2.3-.7,4.4-1.6,6.8-2.1,4.9-1,9.6-2.6,14.6-3.4,6.6-1.4,13.2-2.5,20-3,9.4-1,19-.6,28.5-.6h0Z" fill={fillColor} stroke={strokeColor} strokeWidth="4"/><path d="M347.8,393.5c6.9,6.1,13.8,11.8,22,16.1c4.9,2.4,9.4,5.1,14.6,6.8c4.4,1.8,8.9,3.1,13.4,4.4c8.4,1.5,16.4,3.3,25,3.2c7.5.2,14.9-.3,22.3-1.9c12.5-1.8,24.7-7,35.7-13c5.6-3.3,10.8-7.1,15.9-11.1c1.7-1.5,3.2-3.2,5-4.6L566.6,458.1c-2.5,2.3-5.1,4.6-7.6,7c-3.4,3.4-7.7,6.2-11.4,9.3c-2.1,1.6-4.4,2.9-6.4,4.6c-4.1,3.4-8.8,6-13.3,8.8c-7,4.3-14.7,7.7-22.2,11.1c-8.3,4-16.9,6.4-25.6,9.2c-7.1,1.7-14.2,3.4-21.4,4.8c-8.2,1.3-16.6,2-24.9,2.4h0c-9.5.1-19.1.5-28.5-.5c-6.8-.5-13.4-1.6-20-3c-5-.8-9.7-2.4-14.6-3.4c-2.4-.5-4.5-1.4-6.8-2.1c-8.8-2.2-16.8-5.8-25-9.4c-6.7-3.2-13.4-6.4-19.7-10.6c-13-7.6-25-17.6-36.1-27.8Z" fill={fillColor} stroke={strokeColor} strokeWidth="4"/><path d="M653,336c8.3.4,16.7,1.1,24.9,2.4,7.2,1.4,14.3,3.1,21.4,4.8,8.7,2.8,17.3,5.2,25.6,9.2,7.5,3.4,15.2,6.8,22.2,11.1,4.5,2.8,9.2,5.4,13.3,8.8,2,1.7,4.3,3,6.4,4.6,3.7,3.1,8,5.9,11.4,9.3,2.5,2.4,5.1,4.7,7.6,7-4.5,4.9-9.5,9.3-14,14.2-15.7,15.3-31.2,31-46.9,46.5-1.3,1.4-2.5,2.8-4,4-1.8-1.4-3.3-3.1-5-4.6-5.1-4-10.3-7.8-15.9-11.1-11-6-23.2-11.2-35.7-13-7.4-1.6-14.8-2.1-22.3-1.9-8.6,0-16.6,1.7-25,3.2-4.5,1.3-9,2.6-13.4,4.4-5.2,1.7-9.7,4.4-14.6,6.8-8.2,4.3-15.1,10-22,16.1-12.9-12.6-25.3-25.5-38.2-38-8.4-8.3-16.6-16.7-25-24.8-.7-.7-1.1-1.3-1.5-2.2,11.1-10.2,23.1-20.2,36.1-27.8,6.3-4.2,13-7.4,19.7-10.6,8.2-3.6,16.2-7.2,25-9.4,2.3-.7,4.4-1.6,6.8-2.1,4.9-1,9.6-2.6,14.6-3.4,6.6-1.4,13.2-2.5,20-3,9.4-1,19-.6,28.5-.6h0Z" fill={fillColor} stroke={strokeColor} strokeWidth="4"/><path d="M785.8,393.5c6.9,6.1,13.8,11.8,22,16.1c4.9,2.4,9.4,5.1,14.6,6.8c4.4,1.8,8.9,3.1,13.4,4.4c8.4,1.5,16.4,3.3,25,3.2c7.5.2,14.9-.3,22.3-1.9c12.5-1.8,24.7-7,35.7-13c5.6-3.3,10.8-7.1,15.9-11.1c1.7-1.5,3.2-3.2,5-4.6L1004.6,458.1c-2.5,2.3-5.1,4.6-7.6,7c-3.4,3.4-7.7,6.2-11.4,9.3c-2.1,1.6-4.4,2.9-6.4,4.6c-4.1,3.4-8.8,6-13.3,8.8c-7,4.3-14.7,7.7-22.2,11.1c-8.3,4-16.9,6.4-25.6,9.2c-7.1,1.7-14.2,3.4-21.4,4.8c-8.2,1.3-16.6,2-24.9,2.4h0c-9.5.1-19.1.5-28.5-.5c-6.8-.5-13.4-1.6-20-3c-5-.8-9.7-2.4-14.6-3.4c-2.4-.5-4.5-1.4-6.8-2.1c-8.8-2.2-16.8-5.8-25-9.4c-6.7-3.2-13.4-6.4-19.7-10.6c-13-7.6-25-17.6-36.1-27.8Z" fill={fillColor} stroke={strokeColor} strokeWidth="4"/></svg>;
    case 'serpentine5':
    case 'serpentine6':
    case 'serpentine7':
      // Use serpentine3 shape as base for larger serpentines (they scale automatically)
      return <svg viewBox="70 260 710 290" style={svgStyle} preserveAspectRatio="none"><path d="M215.1,336.1c8.3.4,16.7,1.1,24.9,2.4,7.2,1.4,14.3,3.1,21.4,4.8,8.7,2.8,17.3,5.2,25.6,9.2,7.5,3.4,15.2,6.8,22.2,11.1,4.5,2.8,9.2,5.4,13.3,8.8,2,1.7,4.3,3,6.4,4.6,3.7,3.1,8,5.9,11.4,9.3,2.5,2.4,5.1,4.7,7.6,7-4.5,4.9-9.5,9.3-14,14.2-15.7,15.3-31.2,31-46.9,46.5-1.3,1.4-2.5,2.8-4,4-1.8-1.4-3.3-3.1-5-4.6-5.1-4-10.3-7.8-15.9-11.1-11-6-23.2-11.2-35.7-13-7.4-1.6-14.8-2.1-22.3-1.9-8.6-.1-16.6,1.7-25,3.2-4.5,1.3-9,2.6-13.4,4.4-5.2,1.7-9.7,4.4-14.6,6.8-8.2,4.3-15.1,10-22,16.1-12.9-12.6-25.3-25.5-38.2-38-8.4-8.3-16.6-16.7-25-24.8-.7-.7-1.1-1.3-1.5-2.2,11.1-10.2,23.1-20.2,36.1-27.8,6.3-4.2,13-7.4,19.7-10.6,8.2-3.6,16.2-7.2,25-9.4,2.3-.7,4.4-1.6,6.8-2.1,4.9-1,9.6-2.6,14.6-3.4,6.6-1.4,13.2-2.5,20-3,9.4-1,19-.6,28.5-.6h0Z" fill={fillColor} stroke={strokeColor} strokeWidth="4"/><path d="M347.8,393.5c6.9,6.1,13.8,11.8,22,16.1c4.9,2.4,9.4,5.1,14.6,6.8c4.4,1.8,8.9,3.1,13.4,4.4c8.4,1.5,16.4,3.3,25,3.2c7.5.2,14.9-.3,22.3-1.9c12.5-1.8,24.7-7,35.7-13c5.6-3.3,10.8-7.1,15.9-11.1c1.7-1.5,3.2-3.2,5-4.6L566.6,458.1c-2.5,2.3-5.1,4.6-7.6,7c-3.4,3.4-7.7,6.2-11.4,9.3c-2.1,1.6-4.4,2.9-6.4,4.6c-4.1,3.4-8.8,6-13.3,8.8c-7,4.3-14.7,7.7-22.2,11.1c-8.3,4-16.9,6.4-25.6,9.2c-7.1,1.7-14.2,3.4-21.4,4.8c-8.2,1.3-16.6,2-24.9,2.4h0c-9.5.1-19.1.5-28.5-.5c-6.8-.5-13.4-1.6-20-3c-5-.8-9.7-2.4-14.6-3.4c-2.4-.5-4.5-1.4-6.8-2.1c-8.8-2.2-16.8-5.8-25-9.4c-6.7-3.2-13.4-6.4-19.7-10.6c-13-7.6-25-17.6-36.1-27.8Z" fill={fillColor} stroke={strokeColor} strokeWidth="4"/><path d="M653,336c8.3.4,16.7,1.1,24.9,2.4,7.2,1.4,14.3,3.1,21.4,4.8,8.7,2.8,17.3,5.2,25.6,9.2,7.5,3.4,15.2,6.8,22.2,11.1,4.5,2.8,9.2,5.4,13.3,8.8,2,1.7,4.3,3,6.4,4.6,3.7,3.1,8,5.9,11.4,9.3,2.5,2.4,5.1,4.7,7.6,7-4.5,4.9-9.5,9.3-14,14.2-15.7,15.3-31.2,31-46.9,46.5-1.3,1.4-2.5,2.8-4,4-1.8-1.4-3.3-3.1-5-4.6-5.1-4-10.3-7.8-15.9-11.1-11-6-23.2-11.2-35.7-13-7.4-1.6-14.8-2.1-22.3-1.9-8.6,0-16.6,1.7-25,3.2-4.5,1.3-9,2.6-13.4,4.4-5.2,1.7-9.7,4.4-14.6,6.8-8.2,4.3-15.1,10-22,16.1-12.9-12.6-25.3-25.5-38.2-38-8.4-8.3-16.6-16.7-25-24.8-.7-.7-1.1-1.3-1.5-2.2,11.1-10.2,23.1-20.2,36.1-27.8,6.3-4.2,13-7.4,19.7-10.6,8.2-3.6,16.2-7.2,25-9.4,2.3-.7,4.4-1.6,6.8-2.1,4.9-1,9.6-2.6,14.6-3.4,6.6-1.4,13.2-2.5,20-3,9.4-1,19-.6,28.5-.6h0Z" fill={fillColor} stroke={strokeColor} strokeWidth="4"/></svg>;
    default:
      return null;
  }
}

export default function FloorPlanPreview({ 
  isOpen, 
  onClose, 
  tables, 
  guests, 
  eventName,
  eventLocation,
  venueElements = [],
  customPieces = [],
  floorPlanStyle = {}
}) {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTable, setSelectedTable] = useState(null);
  const [highlightedTable, setHighlightedTable] = useState(null);

  // Merge default styles with custom styles
  const styles = {
    table_fill_color: '#ffffff',
    table_stroke_color: '#d1d5db',
    venue_element_color: '#e5e7eb',
    venue_element_stroke: '#9ca3af',
    custom_piece_fill_color: '#f0eee9',
    custom_piece_stroke_color: '#1e40af',
    seat_color: '#9ca3af',
    background_color: '#f8fafc',
    ...floorPlanStyle
  };

  // Only show tables that have been placed on the canvas
  const placedTables = tables.filter(t => t.position_x !== null && t.position_y !== null);
  
  // Only show custom pieces that have been placed
  const placedCustomPieces = customPieces.filter(p => p.position_x != null && p.position_y != null);
  
  // Only show venue elements that have been placed
  const placedVenueElements = venueElements.filter(el => el.position_x != null && el.position_y != null);

  // Search for a guest
  const searchResults = searchQuery.trim() 
    ? guests.filter(g => 
        g.full_name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  // Handle guest selection from search
  const handleGuestSelect = (guest) => {
    const table = tables.find(t => t.id === guest.table_id);
    if (table) {
      setHighlightedTable(table.id);
      setSelectedTable(table);
      setSearchQuery('');
    }
  };

  // Get guests for a specific table
  const getTableGuests = (tableId) => {
    return guests.filter(g => g.table_id === tableId);
  };

  // Calculate scale to fit all tables and venue elements in view
  const getViewBounds = () => {
    if (placedTables.length === 0 && placedVenueElements.length === 0 && placedCustomPieces.length === 0) {
      return { minX: 0, minY: 0, maxX: 800, maxY: 600, scale: 1 };
    }

    let minX = Infinity, minY = Infinity, maxX = 0, maxY = 0;
    
    // Include tables
    placedTables.forEach(t => {
      const config = SHAPE_CONFIGS[t.shape || 'round'] || SHAPE_CONFIGS.round;
      const w = t.width || config.width;
      const h = t.height || config.height;
      minX = Math.min(minX, t.position_x);
      minY = Math.min(minY, t.position_y);
      maxX = Math.max(maxX, t.position_x + w);
      maxY = Math.max(maxY, t.position_y + h);
    });
    
    // Include venue elements
    placedVenueElements.forEach(el => {
      const w = el.width || 80;
      const h = el.height || 80;
      minX = Math.min(minX, el.position_x);
      minY = Math.min(minY, el.position_y);
      maxX = Math.max(maxX, el.position_x + w);
      maxY = Math.max(maxY, el.position_y + h);
    });
    
    // Include custom pieces
    placedCustomPieces.forEach(p => {
      const w = p.width || 60;
      const h = p.height || 60;
      minX = Math.min(minX, p.position_x);
      minY = Math.min(minY, p.position_y);
      maxX = Math.max(maxX, p.position_x + w);
      maxY = Math.max(maxY, p.position_y + h);
    });

    // Add padding
    minX = Math.max(0, minX - 40);
    minY = Math.max(0, minY - 40);
    maxX = maxX + 40;
    maxY = maxY + 40;

    const width = maxX - minX;
    const height = maxY - minY;
    const scale = Math.min(600 / width, 400 / height, 1);

    return { minX, minY, maxX, maxY, scale };
  };

  const bounds = getViewBounds();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-900 border-slate-700 text-white max-w-4xl max-h-[90vh] overflow-hidden">
        <DialogHeader className="border-b border-slate-700 pb-4">
          <div className="flex items-center justify-between">
            <div>
              <DialogTitle className="font-heading text-xl text-[#D4AF37]">
                Guest View Preview
              </DialogTitle>
              <p className="text-sm text-slate-400 mt-1">
                This is how guests will see the floor plan
              </p>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="text-slate-400 hover:text-white"
            >
              <X className="h-5 w-5" />
            </Button>
          </div>
        </DialogHeader>

        <div className="flex flex-col lg:flex-row gap-4 mt-4 overflow-auto">
          {/* Left Panel - Search & Info */}
          <div className="lg:w-72 space-y-4">
            {/* Event Info */}
            <div className="bg-slate-800/50 p-4 rounded-lg border border-slate-700">
              <h3 className="font-semibold text-white text-lg">{eventName || 'Event'}</h3>
              {eventLocation && (
                <p className="text-sm text-slate-400 flex items-center gap-1 mt-1">
                  <MapPin className="h-3 w-3" />
                  {eventLocation}
                </p>
              )}
            </div>

            {/* Guest Search */}
            <div className="bg-slate-800/50 p-4 rounded-lg border border-slate-700">
              <h4 className="text-sm font-medium text-slate-300 mb-2">Find Your Table</h4>
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
                <Input
                  placeholder="Search your name..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-10 bg-slate-900/50 border-slate-600 h-10"
                  data-testid="preview-search-input"
                />
              </div>
              
              {/* Search Results */}
              {searchResults.length > 0 && (
                <div className="mt-2 space-y-1 max-h-40 overflow-auto">
                  {searchResults.map(guest => (
                    <button
                      key={guest.id}
                      onClick={() => handleGuestSelect(guest)}
                      className="w-full text-left p-2 rounded bg-slate-700/50 hover:bg-slate-700 text-sm text-white transition-colors"
                    >
                      <span className="font-medium">{guest.full_name}</span>
                      {guest.table_name && (
                        <span className="text-slate-400 ml-2">→ {guest.table_name}</span>
                      )}
                    </button>
                  ))}
                </div>
              )}
              
              {searchQuery && searchResults.length === 0 && (
                <p className="text-sm text-slate-500 mt-2">No guests found</p>
              )}
            </div>

            {/* Selected Table Info */}
            {selectedTable && (
              <div className="bg-[#D4AF37]/10 p-4 rounded-lg border border-[#D4AF37]/30">
                <h4 className="font-semibold text-[#D4AF37] text-lg">
                  {selectedTable.table_name}
                </h4>
                <div className="flex items-center gap-2 text-sm text-slate-300 mt-1">
                  <Users className="h-4 w-4" />
                  <span>{getTableGuests(selectedTable.id).length} / {selectedTable.seats || selectedTable.capacity || 8} seats</span>
                </div>
                
                <div className="mt-3 space-y-1">
                  <p className="text-xs text-slate-400 font-medium">Guests at this table:</p>
                  {getTableGuests(selectedTable.id).map(g => (
                    <p key={g.id} className="text-sm text-white">{g.full_name}</p>
                  ))}
                  {getTableGuests(selectedTable.id).length === 0 && (
                    <p className="text-sm text-slate-500 italic">No guests assigned</p>
                  )}
                </div>
                
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => {
                    setSelectedTable(null);
                    setHighlightedTable(null);
                  }}
                  className="mt-3 text-xs text-slate-400 hover:text-white"
                >
                  Clear selection
                </Button>
              </div>
            )}
          </div>

          {/* Right Panel - Floor Plan View */}
          <div className="flex-1 bg-slate-800/30 rounded-lg border border-slate-700 p-4 min-h-[400px]">
            {placedTables.length === 0 ? (
              <div className="h-full flex items-center justify-center text-slate-500">
                <div className="text-center">
                  <MapPin className="h-12 w-12 mx-auto mb-3 opacity-50" />
                  <p>No tables have been arranged yet</p>
                  <p className="text-sm mt-1">Place tables on the floor plan canvas first</p>
                </div>
              </div>
            ) : (
              <div 
                className="relative mx-auto"
                style={{
                  width: (bounds.maxX - bounds.minX) * bounds.scale,
                  height: (bounds.maxY - bounds.minY) * bounds.scale,
                  backgroundColor: styles.background_color,
                }}
              >
                {/* Venue Elements */}
                {placedVenueElements.map(element => {
                  const elWidth = (element.width || 80) * bounds.scale;
                  const elHeight = (element.height || 80) * bounds.scale;
                  
                  return (
                    <div
                      key={element.id}
                      className="absolute flex items-center justify-center text-xs font-medium"
                      style={{
                        left: (element.position_x - bounds.minX) * bounds.scale,
                        top: (element.position_y - bounds.minY) * bounds.scale,
                        width: elWidth,
                        height: elHeight,
                        backgroundColor: styles.venue_element_color,
                        border: `2px solid ${styles.venue_element_stroke}`,
                        borderRadius: '4px',
                        transform: element.rotation ? `rotate(${element.rotation}deg)` : 'none',
                        color: styles.venue_element_font_color || styles.venue_element_stroke,
                        fontSize: `${Math.max(8, (styles.venue_element_font_size || 12) * bounds.scale)}px`,
                      }}
                    >
                      {element.label || element.element_type}
                    </div>
                  );
                })}
                
                {/* Custom Pieces */}
                {placedCustomPieces.map(piece => {
                  const pieceWidth = (piece.width || 60) * bounds.scale;
                  const pieceHeight = (piece.height || 60) * bounds.scale;
                  const isCircle = piece.piece_type === 'piece_circle';
                  const isArc = piece.piece_type === 'piece_wave' || piece.piece_type === 'piece_arc';
                  const fillColor = piece.fill_color || styles.custom_piece_fill_color;
                  const strokeColor = piece.stroke_color || styles.custom_piece_stroke_color;
                  
                  return (
                    <div
                      key={piece.id}
                      className="absolute"
                      style={{
                        left: (piece.position_x - bounds.minX) * bounds.scale,
                        top: (piece.position_y - bounds.minY) * bounds.scale,
                        width: pieceWidth,
                        height: pieceHeight,
                        backgroundColor: isArc ? 'transparent' : fillColor,
                        border: isArc ? 'none' : `2px solid ${strokeColor}`,
                        borderRadius: isCircle ? '50%' : '4px',
                        transform: piece.rotation ? `rotate(${piece.rotation}deg)` : 'none',
                      }}
                    >
                      {isArc && (
                        <svg width="100%" height="100%" viewBox="270 260 320 160" preserveAspectRatio="none">
                          <path 
                            d="M422.7,276.9c8.3.4,16.7,1.1,24.9,2.4,7.2,1.4,14.3,3.1,21.4,4.8,8.7,2.8,17.3,5.2,25.6,9.2,7.5,3.4,15.2,6.8,22.2,11.1,4.5,2.8,9.2,5.4,13.3,8.8,2,1.7,4.3,3,6.4,4.6,3.7,3.1,8,5.9,11.4,9.3,2.5,2.4,5.1,4.7,7.6,7-4.5,4.9-9.5,9.3-14,14.2-15.7,15.3-31.2,31-46.9,46.5-1.3,1.4-2.5,2.8-4,4-1.8-1.4-3.3-3.1-5-4.6-5.1-4-10.3-7.8-15.9-11.1-11-6-23.2-11.2-35.7-13-7.4-1.6-14.8-2.1-22.3-1.9-8.6-.1-16.6,1.7-25,3.2-4.5,1.3-9,2.6-13.4,4.4-5.2,1.7-9.7,4.4-14.6,6.8-8.2,4.3-15.1,10-22,16.1-12.9-12.6-25.3-25.5-38.2-38-8.4-8.3-16.6-16.7-25-24.8-.7-.7-1.1-1.3-1.5-2.2,11.1-10.2,23.1-20.2,36.1-27.8,6.3-4.2,13-7.4,19.7-10.6,8.2-3.6,16.2-7.2,25-9.4,2.3-.7,4.4-1.6,6.8-2.1,4.9-1,9.6-2.6,14.6-3.4,6.6-1.4,13.2-2.5,20-3,9.4-1,19-.6,28.5-.6Z"
                            fill={fillColor}
                            stroke={strokeColor}
                            strokeWidth="4"
                          />
                        </svg>
                      )}
                    </div>
                  );
                })}
                
                {/* Tables */}
                {placedTables.map(table => {
                  const config = SHAPE_CONFIGS[table.shape || 'round'] || SHAPE_CONFIGS.round;
                  const isHighlighted = highlightedTable === table.id;
                  const tableGuests = getTableGuests(table.id);
                  const needsCustomSvg = config.isCustomSvg;
                  const tableWidth = table.width || config.width;
                  const tableHeight = table.height || config.height;
                  const strokeColor = isHighlighted ? '#D4AF37' : styles.table_stroke_color;
                  const fillColor = isHighlighted ? 'rgba(212, 175, 55, 0.4)' : styles.table_fill_color;
                  
                  return (
                    <button
                      key={table.id}
                      onClick={() => {
                        setSelectedTable(table);
                        setHighlightedTable(table.id);
                      }}
                      className={`
                        absolute flex flex-col items-center justify-center
                        transition-all duration-300 cursor-pointer
                        ${isHighlighted 
                          ? 'ring-4 ring-[#D4AF37] scale-110 z-10' 
                          : 'hover:ring-2 hover:ring-slate-500'
                        }
                      `}
                      style={{
                        left: (table.position_x - bounds.minX) * bounds.scale,
                        top: (table.position_y - bounds.minY) * bounds.scale,
                        width: tableWidth * bounds.scale,
                        height: tableHeight * bounds.scale,
                        borderRadius: needsCustomSvg ? '0' : config.borderRadius,
                        backgroundColor: needsCustomSvg ? 'transparent' : fillColor,
                        border: needsCustomSvg ? 'none' : `2px solid ${strokeColor}`,
                        transform: table.rotation ? `rotate(${table.rotation}deg)` : 'none',
                      }}
                      data-testid={`preview-table-${table.id}`}
                    >
                      {needsCustomSvg && renderTableSVG(table.shape, tableWidth, tableHeight, strokeColor, fillColor)}
                      <span 
                        className="text-xs font-semibold text-white truncate px-1 z-10"
                        style={{ maxWidth: tableWidth * bounds.scale - 8 }}
                      >
                        {table.table_name}
                      </span>
                      <span className="text-[10px] text-slate-400 z-10">
                        {tableGuests.length}/{table.seats || table.capacity || 8}
                      </span>
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="mt-4 pt-4 border-t border-slate-700 flex justify-between items-center">
          <p className="text-xs text-slate-500">
            {placedTables.length} tables • {guests.length} total guests
          </p>
          <Button
            onClick={onClose}
            className="bg-[#D4AF37] text-slate-950 hover:bg-[#B5952F]"
          >
            Close Preview
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
